<template>
	<div class="conter">
		<div class="left">
			<div class="lefTop"></div>
			<div class="leftB">
				<ul>
					<li class="imgs"><video src="../assets/anli3.mp4" style="object-fit: fill;width: 100%;height: 100%;" /></video></li>
					<li class="imgs"><img src="../assets/1431335355535.jpg" /></li>
					<li class="imgs"><img src="../assets/chanpin.jpg" /></li>
					<li class="imgs"><img src="../assets/brann.jpg" /></li>
					<li class="imgs"><img src="../assets/brann.jpg" /></li>
				</ul>
			</div>
		</div>
		<div class="chanpinright">
			<h3 class="title">304不锈钢毛细管 无缝不锈钢管 外径1 2 3 4 5 6 7 8 9mm壁厚0.5</h3>
			<div class="xinghao"><span>型号：</span><div>ssss</div></div>
			<div class="price"><span>价格：</span><div>￥2000</div></div>
			<div class="num"><span>数量：</span> <div><a class="reduce">-</a><input type="" name="" id="" value="1" class="inputNum" /><a class='add'>+</a></div></div>
			<div class="shopping">加入购物车</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
			}			
		},
		methods:{
			
		},
		created:function () {
			this.$nextTick(()=>{
			
			    var allLi = document.querySelectorAll('.imgs')
			    			var leftImg = document.querySelector('.leftImg')
			    			var leftVideo = document.querySelector('.leftVideo')
			    			var leftT =document.querySelector('.lefTop')
			    			var conter = document.querySelector('.conter')
			    			var conR = document.querySelector('.chanpinright')
			    			// 遮罩
			    			var zhezhao = document.createElement('div')
			    			zhezhao.style.backgroundColor = 'rgba(255,255,0,0.4)';
			    			zhezhao.style.width = '200px'
			    			zhezhao.style.height = '200px'
			    			zhezhao.style.position = 'absolute'
			    			zhezhao.style.top ='0px'
			    			zhezhao.style.left='0px'
			    			zhezhao.style.zIndex = '10'
			    			
			    			// 右边图片创建
			    			var right = document.createElement('div')
			    			right.style.width = '400px'
			    			right.style.height ='400px'
			    			right.style.backgroundImage = 'url()'
			    			right.style.position ='absolute'
			    			right.style.top ='0px'
			    			right.style.left='0px'
			    			right.style.zIndex = '10'
			    			right.style.backgroundSize ='200% 200%'
			    console.log(allLi)
			    			// 赋值第一张图或者视频
			    			if(allLi[0].children[0].nodeName =='IMG'){
			    				leftT.innerHTML = ''
			    				var img = document.createElement('img')
			    				img.src = allLi[0].firstChild.src
									img.style.width ='400px'
									img.style.height='400px'
			    				leftT.appendChild(img)
			    			}
			    			if(allLi[0].children[0].nodeName =='VIDEO'){
			    				leftT.innerHTML = ''
			    				var video = document.createElement('video')
			    				video.src = allLi[0].firstChild.src
									video.style.width ='400px'
									video.style.height='400px'
									video.style.objectFit='fill'
			    				video.controls='controls'
			    				video.autoplay = 'autoplay'
			    				leftT.appendChild(video)
			    			}
			    			// 移入改变图片和视频
			    			allLi.forEach(function(item,index){				
			    				item.onmouseenter = function(e){
			    					// 先移除border
			    					for(var j= 0 ;j<allLi.length;j++){
			    						allLi[j].style.border = '1px solid transparent'
			    					}
			    					this.style.border = '1px solid rgb(177,30,33)'
			  
			    					if(item.children[0].nodeName =='IMG'){
			    						leftT.innerHTML = ''
			    						var img = document.createElement('img')
			    						img.src = item.firstChild.src
											img.style.width ='400px'
											img.style.height='400px'
											// img.style.maxHeight='100%'
											// img.style.maxWidth='100%'
			    						right.style.backgroundImage = 'url('+item.firstChild.src+')' 
			    						leftT.appendChild(img)
			    					}
			    					if(item.children[0].nodeName =='VIDEO'){
			    						leftT.innerHTML = ''
			    						var video = document.createElement('video')
			    						video.src = item.firstChild.src
											video.style.width ='400px'
											video.style.height='400px'
									video.style.objectFit='fill'
			    						video.controls='controls'
			    						video.autoplay = 'autoplay'
			    						leftT.appendChild(video)
			    					}
			    
			    				}
			    
			    			})
			    			leftT.onmouseenter = function(e){
			    				if(leftT.children[0].nodeName == 'IMG'){
			    					leftT.appendChild(zhezhao)
			    					conR.appendChild(right)
			    				}
			    				
			    			}
			    			leftT.onmousemove = function(e){
			    				if(leftT.children[0].nodeName == 'IMG'){
			    					var x = e.pageX - 100 - conter.offsetLeft;
			    					var y = e.pageY -100 -conter.offsetTop;
			    					if(x<0){x=0};
			    					if(x>200){x=200}
			    					if(y<0){y=0};
			    					if(y>200){y=200};
			    					zhezhao.style.top = y+'px';
			    					zhezhao.style.left = x+'px';
			    					right.style.backgroundPositionX = (-x*2)+'px'
			    					right.style.backgroundPositionY = (-y*2)+'px'
			    				}
			    				
			    			}
			    			leftT.onmouseleave = function(){
			    				conR.removeChild(right)
			    				leftT.removeChild(zhezhao)
			    			}
			
			});
						
		}
	}

</script>

<style scoped>
	*{
		margin: 0px;
		padding: 0px;
		box-sizing: border-box;
	}
	
	
	ul>li{list-style: none;}
	/* 清除浮动 */
	.clearFix::after{
		content: ""; 
	  display: block; 
	  height: 0; 
	  clear: both; 
	  visibility: hidden;  
	}
	
	/* 详情页 */
	.conter{
		width: 1000px;
		margin:0px auto 0px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		position: relative;
		background-color: white;
		padding: 20px;
		border: 1px solid #EEEEEE;
	}
	.conter>.left{
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
	.conter .lefTop{
	/* 			background-image: url(../img/1431335355535.jpg);
		background-size: 100% 100%; */
		width: 400px;
		height: 400px;
/* 		border: 1px solid #EEEEEE; */
		position: relative;
	}
	.conter .lefTop video,.conter .lefTop img{
		width: 400px;
		height: 400px;
		max-height: 100%;
		max-width: 100%;
		position: absolute;
		top: 0px;
		left: 0px;
	}
	.leftB{
		width: 400px;
	}
	.leftB>ul{
		margin: 0px;
		padding: 0px;
	}
	.leftB li{
		float: left;
		width: 65px;
		height: 65px;
		margin:20px 10px 0px;
		border: 1px solid transparent;
	}
	.leftB li img,.leftB li video{
		width: 100%;
		height: 100%;
	}
	.chanpinright{
		margin-left: 20px;
		position: relative;
	}
	.chanpinright .title{
		padding: 20px 0 10px!important;
		font-size: 16px;
		font-weight: 700;
		line-height: 21px;
		color: #3C3C3C;
	}
	.chanpinright .price{
		background-color: #FFF2E8;
		color: #f40;
	}
	.chanpinright .price span,.chanpinright .num>span,.xinghao>span{
	    display: inline;
	    float: left;
	    width: 70px;
	    color: #6c6c6c;
	    font-size: 14px;
	    padding: 0px 8px;
	}
	.chanpinright .price div{
		width: 200px;
	}
	.chanpinright .price,.chanpinright .num{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-direction: row;
		padding: 15px 0px;
	}
	.shopping{
		color: #FFF;
		border-color: #F40;
		background: rgb(177,30,33);
		width: 173px;
		height: 38px;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
	}
	.chanpinright .num{
		margin-bottom: 10px;
	}
	.chanpinright .num>div a{
		display: inline-block;
		width: 26px;
		height: 26px;
		border: 1px solid #ccc;
		text-align: center;
		line-height: 26px;   
		background-color: #ededed;
		vertical-align: middle;
		cursor: pointer;
	}
	
	.chanpinright .num>div input{
		width: 48px;
		height: 26px;
		font-size: 16px;
		line-height: 26px;
		text-align: center;
		color: #666;
		border: 1px solid #CCC;
		outline: 0;
		background: #FFF;
		vertical-align: middle;
	}
	.chanpinright .xinghao{
		display: flex;
		margin: 10px 0px;
		align-items: center;
		justify-content: flex-start;
		font-size: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/components/cpDetail.vue